import { CustomAlertOptions } from './Interface';

export const projectconstants = {
  version: '1.0.0',
  projectName: 'api',
  showLog: true,
};;

const baseUrl = process.env.REACT_APP_BASE_URL || "";

export let rootUrl = `${baseUrl.replace(/\/$/, "")}/${projectconstants.projectName}/`;




// ─── Alert Global ─────────────────────────────────────────────────────────────

export let alertGlobal: CustomAlertOptions | undefined;

export function setalertGlobal(data: CustomAlertOptions): void {
  alertGlobal = data;
}

export function setRootUrl(url: string): void {
  rootUrl = `${url + projectconstants.projectName}/`;
}

export const webservices = {
  getVersionUrl: 'auth/GetAppVersion',
  getDBType: 'auth/GetDBType',
  getValidateMobileNoUrl: 'auth/ValidateMobileNo',
  getGenerateOTPUrl: 'auth/GenerateOTP',
  getConfirmOTPUrl: 'auth/ConfirmOTP',
  getSetMPINndLocation: 'auth/SetMPINndLocation',
  getDelink: 'auth/Delink',
  selectParty: 'auth/SelectParty',
  getDealerList: 'Home/GetDealerInfo',
  getUserInfo: 'UserInformation/GetAllUserInfo',
  getLoginMpin: 'auth/Login',
  getTokenBio: 'auth/GenerateToken',
  getProfileDlinkChk: 'auth/ProfileDlinkChk',
  getGetAllHomeKPI: 'Home/GetAllHomeKPI',
  getRefreshToken: 'auth/RefreshToken',
  getListOfRecomendedproduct: 'Product/ListOfRecomendedproduct',
  getListOfTradesScheme: 'Schemes/GetTradeschmInfo',
  getSchemeDetails: 'Schemes/GetSchemeDetails',
  getProductSchemeMetrics: 'Schemes/CustomerProductMetrics',
  getListOfRecomProducts: 'Schemes/SchemRecomProductList',
  getSaveAddtoCart: 'Product/SaveAddtoCart',
  getViewCart: 'Product/ViewCart',
  DeleteCartItem: 'Product/DeleteCartItem',
  getCartCount: 'Product/RetrieveCartQuantity',
  GetAllOrder: 'OrderDetails/GetAllOrder',
  SaveOrderInfo: 'Product/SaveOrderInfo',
  logOut: 'auth/Logout',
  SavingWishlistItem: 'Product/SavingWishlistItem',
  GettingFavItems: 'Product/GettingFavItems',
  DeleteWishlistItem: 'Product/DeleteWishlistItem',
  FetchingSimilarProducts: 'Product/FetchingSimilarProducts',
  SaveReOrder: 'OrderDetails/SaveReOrder',
  GetBannerImage: 'Home/GetBannerImage',
  CartBannerItem: 'Product/CartBannerItem',
  FetchingCMS: 'UserInformation/FetchingCMS',
  InvoiceDownload: 'PrintInvoice/Invoice',
  RecommendedProductsTimeWise: 'Product/RecommendedProductsTimeWise',
  GetCNFOCSuggestions: 'Transactions/GetCNFOCSuggestions',
  GetTimeWiseKpiDetails: 'Home/GetTimeWiseKpiDetails',
  TxnDetails: 'Transactions/TxnDetails',
  TxnDetailsByPID: 'Transactions/GetTxnDetailsByPID',
  GetPdfTransPrint: 'Transactions/GetPdfTransPrint',
  ProductsPinCodeWise: 'Product/ProductsPinCodeWise',
  GetRunningSchemeProduct: 'Schemes/GetRunningSchemeProduct',
  HotPickItems: 'Product/HotPickItems',
  SaveNavigationHistory: 'UserInformation/Eventlogging',
  PopulateMenu: 'Home/PopulateMenu',
  SavingProfile: 'Home/SavingProfile',
  Downtime: 'Maintenance/GetDownTimeStatus',
};

export const regex = {
  phoneRegex: /^[6-9]\d{9}$/,
  emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  passwordRegex:
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,30}$/,
  cashRegex: /^\d{1,6}$/,
  panRegex: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
  nameRegex: /^[A-Za-z -]*$/,
  numberRegex: /^\d*$/,
  ifscRegex: /^[A-Z]{4}0[A-Z0-9]{6}$/,

  pinRegex: /^[1-9]\d{5}$/,
  nameRegexProfile: /^[A-Za-z -]{3,100}$/,
  upiIdRegex: /^[\w.-]+@[\w.-]+$/,
};

export const formatIndianPrice = (
  value: number | string | null | undefined,
  decimalPlaces: number = 2,
): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;

  if (num === null || num === undefined || Number.isNaN(num)) {
    return '';
  }

  const isNegative = num < 0;
  const fixed = Math.abs(num).toFixed(decimalPlaces);
  const [integerPart, decimalPart] = fixed.split('.');

  // Last 3 digits form the first group; everything before that is
  // grouped in pairs of 2 — this is the actual rule behind lakh/crore
  // grouping (e.g. 1,23,45,678 = 1 crore 23 lakh 45 thousand 678).
  const lastThree = integerPart.slice(-3);
  const remaining = integerPart.slice(0, -3);
  const groupedRemaining = remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
  const groupedInteger = remaining ? `${groupedRemaining},${lastThree}` : lastThree;

  const result = decimalPlaces > 0 ? `${groupedInteger}.${decimalPart}` : groupedInteger;

  return isNegative ? `-${result}` : result;
};
